import React from 'react';
import * as S from './TargetingOngoingLanguages.styled';
import { DeleteIcon } from 'assets/icons';
import { IconButton } from 'components';

const SelectedLang = ({ langCode, language_name, deleteLangBtn }) => {
  return (
    <S.SelectedItem key={langCode}>
      {language_name}
      <IconButton.SmallSize
        isDefaultMuted
        icon={DeleteIcon}
        type={IconButton.btnTypes.tertiary}
        onClick={() => deleteLangBtn(langCode)}
      />
    </S.SelectedItem>
  );
};

export default SelectedLang;
